import React from "react";
import "./WaitingListRemoveBtn.css";

export default class WaitingListRemoveBtn extends React.Component<
  { onClick: any },
  {}
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        onClick={(e) => {
          // The whole row is a link to the customer's profile.
          e.stopPropagation();
          this.props.onClick();
        }}
        className="waiting-list-remove-btn"
      >
        Entfernen
      </div>
    );
  }
}
